var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchApi } from '@api-gen';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { toast } from 'sonner';
import { ACCOUNT_FETCH_ROUTES } from '../constants';
import { convertToClientAccountData, convertToServerAccountData } from '../converters';
export var getCurrentUser = createAsyncThunk(ACCOUNT_FETCH_ROUTES.getCurrent.async_thunk_route, function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchApi.api.accountCurrentList()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, {
                        status: response.status,
                        data: convertToClientAccountData(response.data),
                        fetch_data: {
                            group: ACCOUNT_FETCH_ROUTES.group,
                            fetch_name: ACCOUNT_FETCH_ROUTES.getCurrent.fetch_name,
                        },
                    }];
            case 2:
                error_1 = _a.sent();
                if (error_1 instanceof Error) {
                    return [2 /*return*/, thunkAPI.rejectWithValue({ error: error_1.message })];
                }
                return [2 /*return*/, thunkAPI.rejectWithValue({ error: 'Unknown error' })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var updateUser = createAsyncThunk(ACCOUNT_FETCH_ROUTES.update.async_thunk_route, function (data, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchApi.api.accountUpdateUpdate(convertToServerAccountData(data))];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    toast.success('Успешное редактирование данных о компании!');
                }
                return [2 /*return*/, {
                        payload: response.data,
                        fetch_data: {
                            group: ACCOUNT_FETCH_ROUTES.group,
                            fetch_name: ACCOUNT_FETCH_ROUTES.update.fetch_name,
                        },
                    }];
            case 2:
                error_2 = _a.sent();
                if (error_2 instanceof Error) {
                    return [2 /*return*/, thunkAPI.rejectWithValue({ error: error_2.message })];
                }
                return [2 /*return*/, thunkAPI.rejectWithValue({ error: 'Unknown error' })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var logout = createAsyncThunk(ACCOUNT_FETCH_ROUTES.logout.async_thunk_route, function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchApi.api.authLogoutCreate()];
            case 1:
                response = _b.sent();
                if (response.status === 200) {
                    toast.success('Выход из аккаунта прошел успешно');
                }
                return [2 /*return*/, {
                        status: response.status,
                        data: null,
                        fetch_data: {
                            group: ACCOUNT_FETCH_ROUTES.group,
                            fetch_name: ACCOUNT_FETCH_ROUTES.logout.fetch_name,
                        },
                    }];
            case 2:
                error_3 = _b.sent();
                if (error_3 instanceof AxiosError) {
                    toast.error((_a = error_3.response) === null || _a === void 0 ? void 0 : _a.data);
                    return [2 /*return*/, thunkAPI.rejectWithValue({ error: error_3.message })];
                }
                toast.error('Неизвестная ошибка');
                return [2 /*return*/, thunkAPI.rejectWithValue({ error: 'Unknown error' })];
            case 3: return [2 /*return*/];
        }
    });
}); });
